module.exports = __webpack_public_path__ + "static/media/backward.c161bbcb.svg";